import { ArdoqId, ProvenanceSource } from '@ardoq/api-types';
import { isTruthy } from '@ardoq/common-helpers';
import { logWarn } from '@ardoq/logging';
import { componentApi, scenarioApi } from '@ardoq/api';
import { getActiveScenarioId } from 'streams/activeScenario/activeScenario$';
import {
  hasAIGeneratedScenariosFeature,
  hasScenarioFeature,
} from '@ardoq/features';

export const bulkDeleteComponents = async (
  components: ArdoqId[],
  provenanceSource?: ProvenanceSource
) => {
  if (components.length === 0) return Promise.resolve();

  const componentIds = components.filter(isTruthy);
  if (componentIds.length !== components.length) {
    logWarn(
      Error(
        'bulkDeleteComponents called with components array containing null ids'
      )
    );
  }
  if (componentIds.length === 0) return Promise.resolve();

  const scenarioId =
    (hasScenarioFeature() || hasAIGeneratedScenariosFeature()) &&
    getActiveScenarioId();
  if (scenarioId) {
    return await scenarioApi.deleteComponents(scenarioId, componentIds);
  }
  return await componentApi.deleteComponents(componentIds, provenanceSource);
};
